'use strict';

angular.module('app.influencers', [])

    .controller('AdminInfluencersCtrl', function ($scope, $modal, $http, $rootScope, localStorageService, $window, adminService) {

        var definitions = angular.copy($rootScope.definitions);
        $scope.countries = definitions.countries;
        $scope.languages = definitions.languages;
        $scope.preLoaded = false;
        $scope.InfluencersAll = [];
        $scope.currentPage = 1;
        $scope.pageSize = 25;
        $scope.fieldName = null;
        $scope.order = true;
        $scope.tempOrder = true;
        $scope.currentUrl = $rootScope.apiUrl + 'admin/searchInfluencers';
        $scope.getNumberOfInfluencersURL = $rootScope.apiUrl + 'admin/getNumberOfInfluencers';
        $scope.currentData = null;
        $scope.searchString = null;
        $scope.selectedPlatform = null;
        $scope.selectedCountryId = null;
        $scope.selectedNetworkId = null;
        $scope.selectedLanguageId = null;
        $scope.selectedStatus = null;
        $scope.selectedApproval = null;
        $scope.Header = ["", ""];
        $scope.iconName = "";
        $scope.keyDownScrollCharacter = "";
        $scope.isAdvanceFilters = false;
        $scope.isGettingCount = true;

        $scope.selectedStatus = [
            { id: 1 },
            { id: 4 }
        ];
        angular.forEach($scope.status, function (item) {
            if (item.id == 1 || item.id == 4) {
                item.ticked = true;
            }
        })

        /*$scope.selectedApproval = [
            { id: 2 }
        ];*/

        angular.forEach($scope.approval, function (item) {
            if (item.id == 2) {
                item.ticked = true;
            }
        })

        $scope.searchCountries = function (event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for (var i = 0; i < $scope.countries.length; i++) {
                    if ($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                        var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[i];
                        checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                        break;
                    }
                }
            }
        }

        $scope.networks = [];
        var object = {
            id: 0,
            name: "No Network",
            description: null,
            contact_email: null,
            country: {
                id: null,
                code: null,
                name: null,
                isActive: null
            },
            net_id: null,
            address: null,
            phone: null,
            ticked: false
        }
        $scope.networks.push(object);

        var getPlatformForFilterUrl = $rootScope.apiUrl + 'admin/getPlatformForFilter';
        $http.get(getPlatformForFilterUrl, { loader: false })
            .success(function (responseGetPlatformForFilter) {
                $scope.platforms = responseGetPlatformForFilter.data;

                var getInfluencerActiveUrl = $rootScope.apiUrl + 'admin/getInfluencerActive';
                $http.get(getInfluencerActiveUrl, { loader: false })
                    .success(function (responseGetInfluencerActive) {
                        $scope.status = responseGetInfluencerActive.data;
                        angular.forEach($scope.status, function (item) {
                            if (item.id == 1 || item.id == 4) {
                                item.ticked = true;
                            }
                        })

                        var getInfluencerStatusUrl = $rootScope.apiUrl + 'admin/getInfluencerStatus';
                        $http.get(getInfluencerStatusUrl, { loader: false })
                            .success(function (responseGetInfluencerStatus) {
                                $scope.approval = responseGetInfluencerStatus.data;
                                angular.forEach($scope.approval, function (item) {
                                    if (item.id == 2) {
                                        item.ticked = true;
                                    }
                                })

                                var networksUrl = $rootScope.apiUrl + 'networks';
                                $http.get(networksUrl, { loader: false })
                                    .success(function (responseNetworks) {
                                        angular.forEach(responseNetworks.data, function (item) {
                                            if (item.deletedFlag == 0) {
                                                $scope.networks.push(item);
                                            }
                                        })
                                    })
                            });
                    });
            });

        //PreLoadData to load all influencers
        $scope.preLoadData = function (page) {
            $scope.currentPage = page;
            var dataPreload = {
                searchString: $scope.searchString,
                selectedPlatform: $scope.selectedPlatform,
                selectedCountryId: $scope.selectedCountryId,
                selectedNetworkId: $scope.selectedNetworkId,
                selectedLanguageId: $scope.selectedLanguageId,
                selectedStatus: $scope.selectedStatus,
                selectedApproval: $scope.selectedApproval,
                pageNo: $scope.currentPage,
                sortByColumn: $scope.fieldName,
                sortType: $scope.order
            };

            var urlPreload = $scope.currentUrl;
            $scope.preLoaded = true;

            $scope.sendHttpPOST(dataPreload, urlPreload);
        };

        $scope.sendHttpPOST = function (data, httpUrl, getTotalCount) {
            if (getTotalCount === undefined) {
                getTotalCount = true;
            }
            
            var req = {
                url: httpUrl,
                method: 'POST',
                data: JSON.stringify(data)
            };

            $http(req).success(function (responseInfluencers) {
                $scope.Influencers = responseInfluencers.data;
            }).error(function (responseInfluencers) {
                if (responseInfluencers) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseInfluencers.message;
                }
            });

            var request = {
                url: $scope.getNumberOfInfluencersURL,
                method: 'POST',
                data: JSON.stringify(data),
                loader: false,
                isGetTotalCount: true
            }

            if (getTotalCount) {
                $scope.isGettingCount = true;

                $http(request).success(function (responseNumberOfInfluencers) {
                    $scope.isGettingCount = false;
                    $scope.number = responseNumberOfInfluencers.totalRow;
                    $scope.pagination();
                }).error(function (responseNumberOfInfluencers) {
                    if (responseNumberOfInfluencers) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseNumberOfInfluencers.message;
                    }
                });
            }
        };

        if (!$scope.preLoaded) {
            $scope.preLoadData(1);
        }

        $scope.pagination = function () {
            $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
        };

        //Sort by Column
        $scope.sort = function (fieldname) {
            if ($scope.fieldName != fieldname) {
                $scope.fieldName = fieldname;
                $scope.tempOrder = true;
                $scope.order = true;
            }
            else if ($scope.fieldName == fieldname) {
                $scope.tempOrder = $scope.order;
                $scope.order = !$scope.order;
            }
            if ($scope.tempOrder == true) {
                $scope.iconName = "glyphicon glyphicon-chevron-down";
            } else {
                $scope.iconName = "glyphicon glyphicon-chevron-up";
            }
            if ($scope.fieldName === 'domain') {
                $scope.Header[0] = $scope.iconName;
                $scope.Header[1] = null;
            }
            if ($scope.fieldName === 'country') {
                $scope.Header[0] = null;
                $scope.Header[1] = $scope.iconName;
            }
            $scope.currentPage = 1;
            var dataSortInfluencers = {
                searchString: $scope.searchString,
                selectedPlatform: $scope.selectedPlatform,
                selectedCountryId: $scope.selectedCountryId,
                selectedNetworkId: $scope.selectedNetworkId,
                selectedLanguageId: $scope.selectedLanguageId,
                selectedStatus: $scope.selectedStatus,
                selectedApproval: $scope.selectedApproval,
                pageNo: $scope.currentPage,
                sortByColumn: $scope.fieldName,
                sortType: $scope.order
            };

            var sortInfluencersUrl = $scope.currentUrl;

            $scope.sendHttpPOST(dataSortInfluencers, sortInfluencersUrl, false);
        };

        //Traverse through pages
        $scope.updatePage = function (val) {
            $scope.currentPage = val;
            var updatePageData = {
                searchString: $scope.searchString,
                selectedPlatform: $scope.selectedPlatform,
                selectedCountryId: $scope.selectedCountryId,
                selectedNetworkId: $scope.selectedNetworkId,
                selectedLanguageId: $scope.selectedLanguageId,
                selectedStatus: $scope.selectedStatus,
                selectedApproval: $scope.selectedApproval,
                pageNo: $scope.currentPage,
                sortByColumn: $scope.fieldName,
                sortType: $scope.order
            };

            var updatePageInfluencersUrl = $scope.currentUrl;

            $scope.sendHttpPOST(updatePageData, updatePageInfluencersUrl, false);
        };

        $scope.PlatformIcon = function (platform_id) {
            return adminService.getPlatformIcon(platform_id);
        }

        $scope.ApproveIcon = function (status) {
            return adminService.getApproveIcon(status);
        };

        $scope.ActiveIcon = function (isActive) {
            return adminService.getActiveIcon(isActive);
        };

        $scope.newInfluencerModalHandler = function () {
            var newInfluencersCurrentPage = $scope.currentPage;
            var modalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewInfluencerModal.html?app_v=deployDate',
                controller: 'AddNewInfluencerCtrl'
            });

            $scope.selectedStatus;
            $scope.selectedApproval;
            $scope.modalInstance = modalInstance;
            $scope.flag = false;
            $scope.influencers = true;
            modalInstance.result.then(function () {
                $scope.preLoadData(newInfluencersCurrentPage);
            }, function () {

            });
        };

        $scope.influencerDetails = function (id, infIndex) {
            var influencersDetailsCurrentPage = $scope.currentPage;
            var influencerDetailsModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/influencers_influencer_details.html?app_v=deployDate',
                controller: 'InfluencerDetailsCtrl'
            });

            $scope.selectedStatus;
            $scope.selectedApproval;
            $scope.influencerDetailsModalInstance = influencerDetailsModalInstance;
            $scope.id = id;
            $scope.influencerIndex = infIndex;
            $scope.flag = true;
            $scope.fromInfluencerLog = false;

            influencerDetailsModalInstance.result.then(function () {
                $scope.preLoadData(influencersDetailsCurrentPage);
            }, function (reason) {
                if (reason = 'escape key press') {
                    $scope.preLoadData(influencersDetailsCurrentPage);
                }
            });
        };

        $scope.resetFilter = function () {
            $scope.searchString = null;
            $scope.selectedPlatform = null;
            $scope.selectedCountryId = null;
            $scope.selectedNetworkId = null;
            $scope.selectedLanguageId = null;
            $scope.selectedStatus = [
                { id: 1 },
                { id: 4 }
            ];

            /*$scope.selectedApproval = [
                { id: 2 }
            ];*/

            $scope.platforms.forEach(function (val) {
                val.ticked = false;
            });

            $scope.languages.forEach(function (val) {
                val.ticked = false;
            });

            $scope.countries.forEach(function (val) {
                val.ticked = false;
            });

            $scope.networks.forEach(function (val) {
                val.ticked = false;
            });

            angular.forEach($scope.status, function (item) {
                item.ticked = (item.id == 1 || item.id == 4);
            })

            angular.forEach($scope.approval, function (item) {
                item.ticked = (item.id == 2);
            })
        };

        $scope.searchInfluencers = function () {
            $scope.platforms.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedPlatform = val.id;
                }
            });

            $scope.countries.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedCountryId = val.id;
                }
            });

            $scope.networks.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedNetworkId = val.id;
                }
            });

            $scope.languages.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedLanguageId = val.id;
            });

            var searchInfluencersData = {
                searchString: $scope.searchString,
                selectedPlatform: $scope.selectedPlatform,
                selectedCountryId: $scope.selectedCountryId,
                selectedNetworkId: $scope.selectedNetworkId,
                selectedLanguageId: $scope.selectedLanguageId,
                selectedStatus: $scope.selectedStatus,
                selectedApproval: $scope.selectedApproval,
                pageNo: 1,
                sortByColumn: $scope.fieldName,
                sortType: $scope.order
            };

            $scope.currentPage = 1;

            var searchInfluencersUrl = $scope.currentUrl;

            $scope.sendHttpPOST(searchInfluencersData, searchInfluencersUrl);
        };

        $scope.openAdvanceFilters = function () {
            $scope.isAdvanceFilters = true;
        }

        $scope.closeAdvanceFilters = function () {
            $scope.isAdvanceFilters = false;
        }

        $scope.keyDownScrollCountry = function ($event) {
            $scope.keyDownCharCode = $event.keyCode;
            // angular.forEach not support break function hence using for loop
            for (var i = 0; i < $('.filterOptions').length; i++) {
                var isCountryElement = false;
                var tempElements = $('.filterOptions')[i];

                if (tempElements.firstElementChild.id != null && tempElements.firstElementChild.id !== undefined && tempElements.firstElementChild.id == ("selectCountry")) {
                    isCountryElement = true;
                }

                if (isCountryElement) {
                    var tempCountries = tempElements.firstElementChild.lastElementChild.firstElementChild;
                    for (var k = 0; k < tempCountries.length; k++) {
                        var countryItem = tempCountries[k];
                        var elementCharcode = countryItem.nextElementSibling.firstChild.data.charCodeAt(1);
                        if ($scope.keyDownCharCode == elementCharcode) {
                            var top = countryItem.parentElement.parentElement.parentElement.offsetTop;
                            var parent = countryItem.parentElement.parentElement.parentElement.parentElement;
                            parent.scrollTop = top;
                            break;

                        }
                    }
                }
            }
        };

    })